import axios from "axios";
import { logout } from "./shared/utils/auth";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5001/api/v1",
  timeout: 1000,
});
apiClient.interceptors.request.use(
  (config) => {
    const userDetails = localStorage.getItem("user");
    if (userDetails) {
      const token = JSON.parse(userDetails).token;
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (exception) => {
    return Promise.reject(exception);
  }
);
// Public routes
export const login = async (data) => {
  try {
    return await apiClient.post("/auth/login", data);
  } catch (exception) {
    return { error: true, exception };
  }
};
export const register = async (data) => {
  try {
    return await apiClient.post("/auth/register", data);
  } catch (exception) {
    return { error: true, exception };
  }
};

// Secured routes
export const sendFriendInviations = async (data) => {
  try {
    return await apiClient.post("/friend-invitation/invite", data);
  } catch (exception) {
    checkResponseCode(exception);
    return {
      error: true,
      exception,
    };
  }
};
export const acceptFriendInvitations = async (data) => {
  try {
	
    return await apiClient.post("/friend-invitation/accept", data);
  } catch (exception) {
    checkResponseCode(exception);
    return {
      error: true,
      exception,
    };
  }
};
export const rejectFriendInvitations = async (data) => {
  try {
    return await apiClient.post("/friend-invitation/reject", data);
  } catch (exception) {
    checkResponseCode(exception);
    return {
      error: true,
      exception,
    };
  }
};

export const getProfile = async () => {
  try {
    return await apiClient.get("/auth/me");
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

export const updateProfile = async (data) => {
  try {
    return await apiClient.put("/auth/me/profile", data);
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

export const updatePassword = async (data) => {
  try {
    return await apiClient.put("/auth/me/password", data);
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

export const getServers = async () => {
  try {
    return await apiClient.get("/servers");
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

export const createServer = async (data) => {
  try {
    return await apiClient.post("/servers", data);
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

export const updateServerSettings = async ({ serverId, name, iconUrl }) => {
  try {
    return await apiClient.put(`/servers/${serverId}`, { name, iconUrl });
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

export const getChannelMessages = async ({ serverId, channelId }) => {
  try {
    return await apiClient.get(`/servers/${serverId}/channels/${channelId}/messages`);
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

export const sendChannelMessage = async ({ serverId, channelId, content }) => {
  try {
    return await apiClient.post(`/servers/${serverId}/channels/${channelId}/messages`, { content });
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

export const getServerInvitations = async () => {
  try {
    return await apiClient.get("/servers/invitations");
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

export const sendServerInvitation = async ({ serverId, targetIdentifier }) => {
  try {
    return await apiClient.post(`/servers/${serverId}/invitations`, { targetIdentifier });
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

export const getOutgoingServerInvitations = async (serverId) => {
  try {
    return await apiClient.get(`/servers/${serverId}/invitations/outgoing`);
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

export const revokeServerInvitation = async ({ serverId, invitationId }) => {
  try {
    return await apiClient.delete(`/servers/${serverId}/invitations/${invitationId}`);
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

export const updateChannel = async ({ serverId, channelId, name }) => {
  try {
    return await apiClient.put(`/servers/${serverId}/channels/${channelId}`, { name });
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

export const acceptServerInvitation = async (invitationId) => {
  try {
    return await apiClient.post(`/servers/invitations/${invitationId}/accept`);
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

export const rejectServerInvitation = async (invitationId) => {
  try {
    return await apiClient.post(`/servers/invitations/${invitationId}/reject`);
  } catch (exception) {
    checkResponseCode(exception);
    return { error: true, exception };
  }
};

const checkResponseCode = (err) => {
  const reponseCode = err?.response?.status;
  if (reponseCode) {
    (reponseCode === 401 || reponseCode === 403) && logout();
  }
};
